import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import { Pais, PaisPagingRes, PaisParams } from "@/shared/interfaces";
import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const { get } = erpApi();

/**
 * OBTENER PAIS
 * 
 */


export const useFetchGetPais = (params?: PaisParams) => {
  return useQuery({
    queryKey: [
      'pais',
      ...Object.values(params || {})],
    queryFn: async () => {
      return await getPais(params)
    },
  });
};

export const getPais = async (params?: PaisParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<PaisPagingRes>(
    `${urlBackend}api/v1/pais/?${queryParams}`,
    true
  );
  return resp;
}

// obtener pais por su id

export const useFetchGetPaisById = (id:string) => {
  return useQuery({
    queryKey: [
      'pais',id],
    queryFn: async () => {
      return await getPaisById(id)
    },
  });
};

export const getPaisById = async (id: string) => {
  const resp = await get<Pais>(
    `${urlBackend}api/v1/pais/${id}`,
    true
  );
  return resp;
}


// generico

export const useFetchGetById = <T>(entidad: string, id: string): UseQueryResult<T, Error> => {
  return useQuery({
    // La queryKey se vuelve dinámica: ['pais', '1'] o ['usuario', '5']
    queryKey: [entidad, id],
    queryFn: () => getById<T>(entidad, id),
    // Evita que se ejecute si no hay un ID válido
    enabled: !!id, 
  });
};

export const getById = async <T>(entidad: string, id: string): Promise<T> => {
  const resp = await get<T>(
    `${urlBackend}api/v1/${entidad}/${id}/`,
    true
  );
  return resp.data;
};